const patternConstant = {
    ALPHANUMERIC: /^[a-zA-Z0-9- ?]+$/,
    NUMERIC: /^[0-9]+$/,
    FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
    PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
    ///^\d{0,2}+(\.\d{0,2})?$/
  };
export const generalInfoFields = [
  {
    id: "driver_wage",
    label: "Driver Wage",
    placeHolder: "Enter Driver Wage",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "porter_wage",
    label: "Porter wage",
    placeHolder: "Enter Porter wage",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "packer_wage",
    label: "Packer wage",
    placeHolder: "Enter Packer wage",
    type: "text",
    // md: 6.5,
    // isRequired: true,
    inputProps: {
      maxLength: 7, // Allow values like 9999.99
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  // {
  //   id: "contents_value",
  //   label: "Contents Value",
  //   placeHolder: "Enter Contents Value",
  //   type: "text",
  //   // md: 6.5,
  //   // isRequired: true,
  //   inputProps: {
  //     maxLength: 4,
  //   },
  //   patternAllowed: patternConstant?.NUMERIC,
  // },


];